import { RedriveApiFactory } from "../../../lusca-search-api/LuscaSearchApiFactory";

export const useExecuteRedrive = () => {
  const uploadAndExecuteRedrive = async (file: File, stage: string) => {
    const redriveApi = RedriveApiFactory();

    const uploadUrlResponse = await redriveApi.getRedriveUploadUrl(
      stage,
      file.name
    );

    if (!uploadUrlResponse.data?.uploadUrl || !uploadUrlResponse.data?.s3Uri) {
      throw new Error("Failed to get upload URL");
    }

    const uploadResponse = await fetch(uploadUrlResponse.data.uploadUrl, {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": "text/csv",
      },
    });

    if (!uploadResponse.ok) {
      throw new Error("Failed to upload file to S3");
    }

    return redriveApi.postRedriveInfo(stage, {
      s3_uri: uploadUrlResponse.data.s3Uri,
    });
  };

  const executeRedrive = async (
    file: File,
    selectedStage: string,
    setSelectedExecutionId: (id: string | null) => void,
    setError: (error: string) => void
  ) => {
    try {
      const response = await uploadAndExecuteRedrive(file, selectedStage);

      // Navigate to the orders view for this execution
      if (response.data && response.data.executionId) {
        setSelectedExecutionId(response.data.executionId);
        // Update URL to include the execution ID
        window.history.pushState(
          {},
          '',
          `?stage=${encodeURIComponent(selectedStage)}&executionId=${encodeURIComponent(response.data.executionId)}`
        );
      } else {
        // Fallback to reload if no execution ID
        window.location.reload();
      }
    } catch (err) {
      setError(`Failed to execute redrive: ${err instanceof Error ? err.message : String(err)}`);
    }
  };

  const executeSingleRedrive = async (orderId: string, stage: string) => {
    const blob = new Blob([orderId], { type: "text/csv" });
    const file = new File([blob], "single_order.csv", { type: "text/csv" });

    return uploadAndExecuteRedrive(file, stage);
  };

  return { executeRedrive, executeSingleRedrive };
};
